import Axios from 'axios'
import {
    Message
} from 'element-ui'
import Store from '@/store'
import Router from '../router/index.js'
// Axios.defaults.baseURL = 'http://10.220.9.204:2001'

Axios.interceptors.request.use(config => {
    config.headers.Token = Store.state.token
    return config
}, err => {
    return Promise.reject(err)
})

Axios.interceptors.response.use(response => {

    if (response.data.code === 401) {
        Message.warning('请重新登录')
        // Store.commit('updateToken', {token: null})
        setTimeout(() => {
            window.location.href = '/login'
        }, 500)
        return
    }
    if ( response.data.code === 200) {
        return response.data
    } else {
        Message.warning(response.data.msg || response.data.message)
        return Promise.reject(response.data)
    }
}, error => {
    return Promise.reject(error)
})

export default Axios
